import { render } from "./Loading.vue?vue&type=template&id=69bde1ab"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=69bde1ab&lang=css"
script.render = render

export default script